module.exports = __webpack_public_path__ + "static/img/11.2680d67.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/11.png
// module id = YHGZ
// module chunks = 0